import './SegmentedControl.css'

export interface SegmentedControlOption {
  value: string
  label: string
}

export interface SegmentedControlProps {
  options: SegmentedControlOption[]
  value: string
  onChange: (value: string) => void
  /** Nom accessible du groupe (« Filtrer les familles ») : sans lui, un
   * lecteur d'écran annonce trois boutons sans dire à quoi ils servent. */
  label?: string
}

/** Small pill-shaped toggle between a short list of mutually exclusive options. */
export function SegmentedControl({ options, value, onChange, label }: SegmentedControlProps) {
  return (
    <div className="azoya-segmented-control" role="group" aria-label={label}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          aria-pressed={opt.value === value}
          className={opt.value === value ? 'is-active' : ''}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
